<template>
  <BaseAZPopover v-model:open="showPopup" :show-close-icon="false" align="start" :side-offset="10">
    <template #reference>
      <div class="relative" @click.stop="showPopup = !showPopup">
        <div
          v-if="filterLength > 0"
          class="absolute right-0 h-5 w-5 rounded-full bg-black text-center text-sm text-white leading-5 -top-1"
        >
          {{ filterLength }}
        </div>
        <div
          h="12"
          flex="~ 1 items-center"
          b="~ 2 solid #777474"
          rounded="full"
          bg="#F3F3F3"
          p="x-6"
          class="line-clamp-1"
        >
          <img :width="16" src="~assets/icons/icon-huge.png" />
          <div class="line-clamp-1 ml-2 text-lg text-[#777474]">
            {{ t('key.filter.booking.options') }}
          </div>
        </div>
      </div>
    </template>
    <template #default>
      <div class="w-70">
        <div class="px-1 space-y-2.5">
          <BaseAZCheckBox
            v-model="filterParams.freeCancellation"
            name="Free cancellation"
            icon-size="1.5rem"
            class="box-border w-full flex items-center"
            @change="onConfirm"
          >
            <span class="text-sm text-[#121212]" font="500">{{ t('key.experience.filter.free.cancellation') }}</span>
            <el-tooltip
              :content="t('key.filter.cancellation.tooltip')"
              placement="top"
              effect="light"
            >
              <img w="4" h="4" :src="infoSvg" m="l-1" />
            </el-tooltip>
          </BaseAZCheckBox>
          <BaseAZCheckBox
            v-model="filterParams.instantConfirmation"
            icon-size="1.5rem"
            name="Instant confirmation"
            class="box-border w-full flex items-center"
            @change="onConfirm"
          >
            <span class="text-sm text-[#121212]" font="500">{{ t('key.experience.filter.instant.confirmation') }}</span>
          </BaseAZCheckBox>
        </div>
      </div>
    </template>
  </BaseAZPopover>
</template>

<script lang="ts" setup>
import infoSvg from '@/assets/info.svg'

const { t } = useI18n()
const showPopup = ref(false)
const { filterParams, getExperienceDetail } = useExperienceDetail()

const filterLength = computed(() => {
  return (filterParams.value.freeCancellation ? 1 : 0) + (filterParams.value.instantConfirmation ? 1 : 0)
})

function onConfirm() {
  getExperienceDetail()
  showPopup.value = false
}
</script>

<style>

</style>
